import React, { useState } from 'react'
import { DropdownButton, Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useAccess } from 'contexts/AccessContext'
import styles from './Option.module.scss'

interface IProps {
  item: any
  onDeleteClick: any
  onEditClick: any
  disable: boolean
}

const Options: React.FC<IProps> = ({
  item,
  onDeleteClick,
  onEditClick,
  disable = false,
}) => {
  const { t } = useTranslation()
  const { can } = useAccess()
  const [loading] = useState(false)
  const [show, setShow] = useState(false)

  const canManageFolders = can('manageInternalCourses')

  const handleDropdownClick = (nextShow: boolean) => {
    if (!disable) {
      setShow(nextShow)
    }
  }

  if (!canManageFolders) return null

  return (
    <DropdownButton
      id="dropdown-menu-align-right"
      show={show}
      alignRight
      disabled={disable}
      className={styles.actionSelect}
      title={
        !loading ? (
          <FontAwesomeIcon icon={faEllipsisV} size="1x" className="mr-2" />
        ) : (
          <div className="d-flex justify-content-center">
            <Spinner size={'sm'} animation="border" role="status">
              <span className="sr-only">
                {t('administration.folders.options.loading')}
              </span>
            </Spinner>
          </div>
        )
      }
      onClick={() => handleDropdownClick(!show)}
      onToggle={() => handleDropdownClick(!show)}
    >
      {show && (
        <>
          {item.id != 1 && (
            <a onClick={() => onDeleteClick(item.id || 0)}>
              {t('administration.folders.options.delete')}
            </a>
          )}
          <a onClick={() => onEditClick(item.id || 0)}>
            {t('administration.folders.options.edit')}
          </a>
        </>
      )}
    </DropdownButton>
  )
}

export default Options
